'use strict';

angular.module('DoohApps').service('adminBLL', ['Admin', 'UserRoleData', 'AccessRightsData', 'UploadFileStorage', 'AppStoreData', 'Account', 'FileUpload', 'FileDownloadHelper',
    function (Admin, UserRoleData, AccessRightsData, UploadFileStorage, AppStoreData, Account, FileUpload, FileDownloadHelper) {
        this.getUserByInviteCode = function (callback, code) {
            Account.getUserByInviteCode(function (data) { responseHandler(callback, data) }, code);
        };

        this.checkAppVerBeforeDelete = function (callback, appId) {
            Admin.checkAppVerBeforeDelete(function (data) { callback(data) }, appId);
        }

        this.deleteAppVersion = function (callback, verId) {
            Admin.deleteAppVersion(function (data) { callback(data) }, verId);
        }

        this.GetApps = function (callback, objectFilterOptions) {
            Admin.getApps(function (data) { callback(data) }, objectFilterOptions);
        }

        this.getAppVersionListByAppId = function (callback, appId) {
            Admin.getAppVersionListByAppId(function (data) {
                responseHandler(callback, data);
            }, appId);
        }

        this.GetAppByIdAdmin = function (callback, id, verId) {
            Admin.getAppByIdAdmin(callback, id, verId);
        }

        this.UpdateApp = function (callback, app) {
            Admin.updateApp(function (data) { responseHandler(callback, data) }, app);
        }

        function returnContent(callback, data) {
            callback(data.Data.Content);
        }

        function responseHandler(callback, data) {
            callback({
                hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: getErrorMessage(data),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
            });
        }

        function getErrorMessage(data) {
            if (data.hasError)
                return data.errors[0];

            return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
        }

        this.GetUserRoles = function (callback, filter) {
            UserRoleData.getUserRoles(function (data) { responseHandler(callback, data) }, filter);
        }

        this.GetAccessRights = function (callback, roleID) {
            AccessRightsData.getAccessRights(function (data) { responseHandler(callback, data) }, roleID);
        }

        this.saveRole = function (callback, role) {
            UserRoleData.saveRole(function (data) { responseHandler(callback, data) }, role);
        }

        this.DeleteRole = function (callback, Id) {
            UserRoleData.deleteRole(function (data) { responseHandler(callback, data) }, Id);
        }

        this.getAllRoles = function (callback) {
            UserRoleData.getAllRoles(function (data) { responseHandler(callback, data) });
        }

        this.ExportSettings = function (callback, exportOptions) {
            Admin.ExportSettings(function (data) { callback(data) }, exportOptions);
        }
        this.ImportSettings = function (callback, importOptions) {
            Admin.ImportSettings(function (data) { callback(data) }, importOptions);
        }
        this.ResolveImportConflict = function (callback, resolve) {
            Admin.resolveImportConflict(function (data) { callback(data) }, resolve);
        }

        this.AddNewApp = function (callback, app) {
            Admin.addApp(function (data) { callback(data) }, app);
        }

        this.checkAppBeforeDelete = function (callback, appId) {
            Admin.checkAppBeforeDelete(function (data) { callback(data) }, appId);
        }
        this.deleteApp = function (callback, Id) {
            Admin.deleteApp(function (data) { callback(data) }, Id);
        }
        this.copyApplication = function (callback, appData) {
            Admin.copyApplication(function (data) { callback(data) }, appData);
        }
        this.getAppUsage = function (callback, filter) {
            AppStoreData.getAppUsage(function (data) { callback(data) }, filter);
        }
        this.getCampaignUsage = function (callback, filter) {
            AppStoreData.getCampaignUsage(function (data) { callback(data) }, filter);
        },
            this.getUserRoleUsers = function (callback, id) {
                UserRoleData.getUserRoleUsers(function (data) { callback(data); }, id);
            }
        this.GetVersionFiles = function (callback, version) {
            Admin.GetVersionFiles(function (data) { responseHandler(callback, data) }, version);
        }

        this.AddNewVersionFile = function (callback, file) {
            Admin.AddNewVersionFile(function (data) { responseHandler(callback, data) }, file);
        }
        this.UpdateVersionFile = function (callback, versionFile) {
            Admin.UpdateVersionFile(function (data) { responseHandler(callback, data) }, versionFile);
        }

        this.CheckAppVersionFile = function (callback, fileid) {
            Admin.CheckAppVersionFile(function (data) { responseHandler(callback, data) }, fileid);
        }

        this.DeleteVersionFile = function (callback, fileID, versionID) {
            Admin.DeleteVersionFile(function (data) { responseHandler(callback, data) }, fileID, versionID);
        }

        this.GetExistingVersionFiles = function (callback, ExistingVersionFiles) {
            Admin.GetExistingVersionFiles(function (data) { responseHandler(callback, data) }, ExistingVersionFiles);
        }

        this.AddExistingVersionFiles = function (callback, files) {
            Admin.AddExistingVersionFiles(function (data) { responseHandler(callback, data) }, files);
        }

        this.getExecutableActions = function (callback, verID) {
            Admin.getExecutableActions(function (data) { responseHandler(callback, data) }, verID);
        }

        this.AddExecutableAction = function (callback, VerExeAction) {
            Admin.AddExecutableAction(function (data) { responseHandler(callback, data) }, VerExeAction);
        }

        this.updateExecutableAction = function (callback, VerExeAction) {
            Admin.updateExecutableAction(function (data) { responseHandler(callback, data) }, VerExeAction);
        }

        this.deleteExecutableAction = function (callback, id) {
            Admin.deleteExecutableAction(function (data) { responseHandler(callback, data) }, id);
        }

        this.getRequirementTypes = function (callback) {
            Admin.getRequirementTypes(function (data) { returnContent(callback, data) });
        }

        this.addRemoveRequirements = function (callback, requirements) {
            Admin.addRemoveAppRequirements(function (data) { callback(data) }, requirements);
        }

        this.updateAppImages = function (callback, appData) {
            Admin.updateAppImages(function (data) { callback(data) }, appData);
        }
        this.updateAppVersion = function (callback, appVer) {
            Admin.updateAppVersion(function (data) { responseHandler(callback, data) }, appVer);
        }

        this.addAppVersion = function (callback, appversion) {
            Admin.addAppVersion(function (data) { responseHandler(callback, data) }, appversion);
        }

        this.GetAllApps = function (callback) {
            Admin.getAllApps(function (data) { returnContent(callback, data) });
        }

        this.SaveCompanyLogo = function (onProgress, onSuccess, onError, companyId) {
            var files = UploadFileStorage.GetFiles();
            var uploadUrlReceivedHandler = createFileUploadUrlReceivedHandler(files[0], onProgress, onSuccess, onError, companyId);
            if (files[0].type.indexOf('text') == -1) {
                FileUpload.getFileUploadUrl(uploadUrlReceivedHandler, encodeURIComponent(files[0].name), companyId);
            }
        }

        function createFileUploadUrlReceivedHandler(file, onProgress, onSuccess, onError, companyId) {
            return function (url, token) {
                FileUpload.upload({
                    file,
                    url,
                    token,
                    onProgress,
                    onSuccess,
                    onError,
                    companyId
                });
            }
        }

        this.updateCompanyLogo = function (callback, url, companyId) {
            Admin.updateCompanyLogo(function (data) {
                responseHandler(callback, data);
            }, { logoURL: url, companyID: companyId });
        }

        this.deleteCompanyLogo = function (callback, companyID) {
            Admin.deleteCompanyLogo(function (data) {
                callback(data);
            }, companyID);
        }

        this.saveConfiguratorBlocks = function (callback, blocks) {
            Admin.saveConfiguratorBlocks(function (data) { responseHandler(callback, data) }, blocks);
        }

        this.moveAssets = function (callback, data) {
            Admin.moveAssets(function (data) {
                responseHandler(callback, data)
            }, data);
        }

        this.getCustomCode = function (callback, data) {
            Admin.getCustomCode(function (data) {
                responseHandler(callback, data)
            }, data);
        }

        this.saveCustomCode = function (callback, data) {
            Admin.saveCustomCode(function (data) {
                responseHandler(callback, data)
            }, data);
        }
        this.copyVersion = function (callback, appData) {
            Admin.copyVersion(function (data) { callback(data) }, appData);
        }

        this.getFileUrl = function (fileID) {
            Admin.getFileUrl(function (data) {
                responseHandler(FileDownloadHelper.downloadFileFromResponse, data);
            }, fileID);
        }
    }]);
